// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__30qGz","content":"Consent_content__nktsu","footer":"Consent_footer__zPIqF"};